import apisauce from 'apisauce'

export default {
  create: () => {
    const api = apisauce.create({
      baseURL: `${process.env.BASE_URL}/customer_portal`,
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 30000,
    })

    api.axiosInstance.interceptors.request.use(function (config) {
      config.headers['APPOINTO-TOKEN'] = window.customer_token
      return config
    })

    return {
      getBookings: (params) => api.get(`bookings`, params),
      getBookingDetails: (params) => api.get(`bookings`, params),
      getConflicts: () => api.get(`/conflicts`),
      sendCodeEmail: (params) => api.put(`/login/send_otp`, params),
      verifyCode: (params) => api.put(`/login/verify_otp`, params),
      onLogout: () => api.put(`/settings/logout`),
      me: (params) => api.get(`/login/me`, params),
      getBookingSubscription: (id) =>
        api.get(`appointment_subscriptions/${id}`),
      getSubscriptions: () => api.get(`/appointment_subscriptions`),
      deleteSubscription: (id) => api.delete(`appointment_subscriptions/${id}`),
      updateCustomerPaymentMethod: (params) =>
        api.put(
          `/appointment_subscriptions/update_customer_payment_method`,
          params
        ),
    }
  },
}
